module.exports = __webpack_public_path__ + "static/Andy-ff5246e0eacd70b94f69135539a13f57.png";